export default "__VITE_ASSET__41f5cc53__"